import utils from './utils';
import api from './api';

function redirectTo({redirect_to}) {
    if (redirect_to) {
        return redirect_to;
    }
    const url = new URL(window.location.href);
    url.searchParams.set('checkemail', 'confirm');
    url.searchParams.delete('action');
    return url.href;
}

async function handleSubmit(event) {
    event.preventDefault();

    const form = event.target;

    utils.setLoading({form: event.target, isLoading: true});

    const body = utils.formData({form});
    try {
        const res = await api.post('/lostpassword', body);
        if (res.status) {
            window.location.href = redirectTo(body);
        } else {
            utils.showMessage(res.errors.messages[0]);
        }
    } catch( e ) {
        console.error( e.toString() );
        utils.showMessage( {form, message: e.toString()} );
    }

    utils.setLoading({form: event.target, isLoading: false});
}

export default function () {
    document.querySelectorAll('.payments-password-lost-form').forEach((element) => {
        element.addEventListener('submit', handleSubmit);
    });
}